<div class="sw-cms-preview-block-moorl-grid-layout-four">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
</div>